export { default } from './PrivacyPolicy'
